import React from "react";
import "./PolicyPages.scss";

function TermsConditions() {
  return (
    <div className="policy-page">
      <div className="container">

        <div className="policy-card">
          <h1>Terms & Conditions</h1>

          <section>
            <h3>Acceptance of Terms</h3>
            <p>
              By using our services, you agree to comply with these terms
              and conditions.
            </p>
          </section>

          <section>
            <h3>Services</h3>
            <p>
              UIPlus Technologies provides software development, web
              applications, ERP solutions, and WhatsApp automation services.
            </p>
          </section>

          <section>
            <h3>User Responsibilities</h3>
            <p>
              Users must provide accurate information and use services
              lawfully.
            </p>
          </section>

          <section>
            <h3>Limitation of Liability</h3>
            <p>
              We are not responsible for indirect damages resulting from
              service usage.
            </p>
          </section>

          <section>
            <h3>Contact Information</h3>
            <p>Email: admin@uiplus.in</p>
            <p>Website: https://uiplus.in</p>
          </section>

        </div>

      </div>
    </div>
  );
}

export default TermsConditions;